import styled from "styled-components";
import { colors } from "@/constants";

export const OfflineMessage = styled.div`
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  width: fit-content;
  color: ${colors.brand.white};
`;

export const OfflineOffset = styled.div`
  height: 34px;
`;

export const OfflineMessageContainerStyle = styled.div<{ $isScrolled: boolean }>`
  top: 0px;
  transform: ${({ $isScrolled }) => $isScrolled ? 'translateX(-50%) translateY(calc(-100% + 2px))' : 'translateX(-50%) translateY(0)'};
  transition: transform 0.2s ease-in-out;
  left: 0;
  width: 100%;
  position: fixed;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  z-index: 9999999;
  height: 34px;
  max-width: var(--mobile);
  background-color: ${colors.alert.red200};
  box-shadow: 0px 4px 4px 0px ${colors.shadown2};
`;